// TrustmateWidget.js
import React from 'react';
// <--- IMPORT

import { useTrustmateWidgetScript } from '@Theme/natucare/hooks/useTrustmateWidget';
import './TrustmateWidget.scss';
import * as styles from './TrustmateWidget.module.scss';
const WIDGET_IDS = {
  pl: 'c6467449-2b8e-468a-b2e1-87b6c253f7e9',
  intl: 'eb77d249-e80a-459e-b0f9-9d87dcf19e19'
};
const TrustmateWidget = ({
  locale = 'pl'
}) => {
  const widgetId = WIDGET_IDS[locale.toLowerCase()] || WIDGET_IDS.intl;
  useTrustmateWidgetScript(widgetId);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    id: widgetId,
    className: "nc-footer-trustmate-widget"
  }));
};

// ✅ PropTypes

export default TrustmateWidget;